export default function HiloRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>


            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>High Low</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To guess whether the next card drawn is Higher or Lower or Equal to the Joker card on the Table. </p>

                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"> <b>Hands dealt</b>: 1 </p>
                                            <p class="pt20"><b>Bets:</b> Dealer Draws the Ante card, Joker card is present on the Table.</p>
                                            <p class="pt20"><b>Lower wins:</b> If Ante card is Lower to Joker. </p>
                                            <p class="pt20"><b>Higher wins:</b> If Ante card is Higher to Joker.</p>
                                            <p class="pt20"><b>Snap wins:</b> If Ante card is same as Joker card. The Ante card becomes the Joker for next round.</p>
                                            <p class="pt20"><b>Number Ranking:</b> Lowest to highest: 2, 3, 4, 5, 6, 7,8, 9, 10, Jack, Queen, King, and Ace (Ace is "14" and King is "13". Queen is “12” &amp; Jack is “11”)</p>

                                        </div>
                                    </center>
                                    <div>
                                        <center><h3>PAYOUT</h3></center>
                                        <ol>
                                            <li class="lit20" style={{ textAlign: "left" }}>1. Payouts are dynamic based on the Joker card. </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}